import type { Schedule } from "src/types";

export const getUniqueScheduleParts = (schedules: Schedule[] = []) => {
  const parts = schedules
    .map((scheduleByDate) =>
      (scheduleByDate.schedules || []).flatMap((scheduleItem) => {
        if (scheduleItem.event_part?.event_type_custom_text) {
          return scheduleItem.event_part?.event_type_custom_text;
        }
        return scheduleItem.event_part?.event_part_type;
      })
    )
    .flat();
  return Array.from(new Set(parts));
};
